<template>
  <div id="AdvertMgmtOld" style=" margin: 0 auto;    background: white;">
    <div ref="header" class="header-box">
      <div class="header-line">
        <span class="header-label">产品类型</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productType">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="product in productList" :key="product.productType" :label="product.productName" :value="product.productType"></el-option>
        </el-select>
        <span class="header-label">产品颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productColor">
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
        <span class="header-label">视图模式</span>
        <el-select placeholder="请选择" size="small" v-model="viewModel">
          <el-option label="精简" value="1"></el-option>
          <el-option label="全量" value="2"></el-option>
        </el-select>
        <span class="header-label">SKU</span>
        <el-input placeholder="请输入SKU" size="small" clearable v-model="sku">
        </el-input>
        <el-button type="primary" size="small" @click="queryBtn">查询</el-button>
        <el-button type="primary" size="small" @click="clearState">清除状态</el-button>
      </div>
    </div>
    <el-table ref="table" :data="tableData" stripe size="mini" :height="screenHeight" :highlight-current-row="true" show-summary border>
      <el-table-column prop="sku" label="" width="40px" align="right" type="expand" :key="10">
        <template slot-scope="listScope">
          <el-table class="child-table" :data="listScope.row.campainList" row-key="_id" lazy :load="load" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" stripe size="mini" border style="width: 991px; margin-left:515px">

            <el-table-column prop="adTypeText" label="广告名称" width="100px" align="right">
            </el-table-column>
            <el-table-column prop="Daily Budget" label="日预算" width="80px" align="right">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.isDetail" v-model="scope.row['Daily Budget']" @change="onDailyBudgetChange(scope.row)" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Bid" label="单价" width="80px" align="right">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.isDetail && scope.row.relateAdvert" v-model="scope.row.relateAdvert.Bid" @change="onBidChange(scope.row.relateAdvert)" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="recommandBid" label="推荐单价" width="40px" align="right">
              <template v-slot="scope">
                <div :class="getRecommandBidStyleClass(scope.row.relateAdvert)" @click="onRecommandBidClick(scope.row.relateAdvert)" style="cursor: pointer;">{{ scope.row.relateAdvert && scope.row.relateAdvert.recommandBid }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140px" align="right">
              <template slot-scope="scope">
                <div v-if="scope.row.isDetail">{{ scope.row.dateDes }}</div>
                <template v-else>
                  <el-button type="text" size="small" @click="detailPage(scope.row)">投放词详情</el-button>
                  <el-button type="text" size="small" @click="searchKeydetailPage(scope.row)">搜索词详情</el-button>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="50px" align="right">
              <template slot-scope="scope">
                <el-switch v-if="!scope.row.isDetail" v-model="scope.row.State" @change="onStateChange(scope.row, listScope.row)" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="CPC" label="CPC" width="50px" align="right">
            </el-table-column>
            <el-table-column prop="Impressions" label="展现量" width="50px" align="right">
            </el-table-column>
            <el-table-column prop="Clicks" label="点击量" width="50px" align="right">
            </el-table-column>
            <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right">
              <template slot-scope="scope">
                {{ (scope.row["Click-through Rate"]*100).toFixed(2)+"%" }}
              </template>
            </el-table-column>
            <el-table-column prop="Spend" label="花费" width="50px" align="right">
              <template slot-scope="scope">
                {{ (Number(scope.row.Spend)).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="Sales" label="销售额" width="50px" align="right">
              <template slot-scope="scope">
                {{ (Number(scope.row.Sales)).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="Orders" label="订单数" width="50px" align="right">
            </el-table-column>
            <el-table-column prop="Units" label="销售数量" width="50px" align="right">
            </el-table-column>
            <el-table-column prop="Conversion Rate" label="转化率" width="50px" align="right">
            </el-table-column>
            <el-table-column prop="ROAS" label="ROAS" width="50px" align="right">
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="sku" label="SKU" width="180px" align="right" :key="11">
      </el-table-column>
      <!-- <el-table-column prop="asin" label="Asin" width="60px" align="right" sortable>
      </el-table-column> -->
      <el-table-column prop="productName" label="名称" width="70px" align="right" v-if="viewModel == 2" :key="12" sortable>
      </el-table-column>
      <el-table-column prop="model" label="机型" width="60px" align="right" v-if="viewModel == 2" :key="13" sortable>
      </el-table-column>
      <el-table-column prop="productColorName" label="颜色" width="60px" align="right" v-if="viewModel == 2" :key="14" sortable>
      </el-table-column>
      <el-table-column prop="speed" label="增速" width="40px" align="right" :key="15" sortable>
      </el-table-column>
      <!-- <el-table-column prop="inventoryAge0To90Days" label="0~90日库存" width="40px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="inventoryAge91To180Days" label="91~180日库存" width="40px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getInventoryAgeStyleClass(scope.row.inventoryAge91To180Days)">{{ scope.row.inventoryAge91To180Days }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sellThrough" label="售出率" width="40px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getSellThroughStyleClass(scope.row.sellThrough)">{{ scope.row.sellThrough }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="unitsShippedT90" label="90日订单" width="60px" align="right" sortable>
      </el-table-column> -->
      <el-table-column prop="inventoryCount" label="库存" width="40px" align="right" :key="16" sortable>
      </el-table-column>
      <el-table-column prop="availableQuantity" label="可用" width="40px" style="color:green" align="right" :key="17" sortable>
        <template v-slot="scope">
          <div class="greenText">{{ scope.row.availableQuantity }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="reservedQuantity" label="预留" width="40px" style="color:greenyellow" align="right" :key="18" sortable>
        <template v-slot="scope">
          <div class="greenYellowText">{{ scope.row.reservedQuantity }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="inboundQuantity" label="入库" width="40px" align="right" :key="19" sortable>
      </el-table-column>
      <el-table-column prop="inboundWorking" label="处理中" width="40px" align="right" v-if="viewModel == 2" :key="110" sortable>
      </el-table-column>
      <el-table-column prop="inboundShipped" label="已发货" width="40px" align="right" v-if="viewModel == 2" :key="111" sortable>
      </el-table-column>
      <el-table-column prop="inboundReceived" label="正在接收" width="40px" style="color:goldenrod" align="right" v-if="viewModel == 2" :key="112" sortable>
        <template v-slot="scope">
          <div class="yellowText">{{ scope.row.inboundReceived }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="inventoryDay" label="库存天数" width="55px" align="right" :key="113" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.inventoryDay)">{{ scope.row.inventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableInventoryDay" label="可用库存天数" width="55px" align="right" :key="114" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.availableInventoryDay)">{{ scope.row.availableInventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalVisit" label="合计访客" width="55px" align="right" :key="115" sortable>
      </el-table-column>
      <el-table-column prop="orderRate" label="转化率" width="50px" align="right" :key="116" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.orderRate>=0 ? Math.round(scope.row.orderRate*10000)/100 + "%" : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalOrder" label="合计订单" width="55px" align="right" :key="117" sortable>
      </el-table-column>
      <el-table-column prop="last7DayCount" label="七日订单" width="55px" align="right" :key="118" sortable>
      </el-table-column>
      <el-table-column prop="lastDayCount" label="昨日订单" width="55px" align="right" :key="1181" sortable>
      </el-table-column>
      <el-table-column prop="price" label="价格" width="40px" align="right" :key="119" sortable>
      </el-table-column>
      <el-table-column prop="majorLevel" label="等级" width="40px" align="right" :key="120" sortable>
        <template v-slot="scope">
          <div :class="getMajorLevelStyleClass(scope.row)">{{ scope.row.majorLevel>0 ? scope.row.majorLevel : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="State" label="推荐状态" width="80px" align="right" :key="1200" sortable>
        <template v-slot="scope">
          <div :class="getRecommendStyleClass(scope.row)">{{ getRecommendState(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="50px" align="right" :key="121" sortable>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.State" @change="onProductStateChange(scope.row)" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="50px" :key="122">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="productDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="CPC" label="CPC" width="50px" align="right" :key="123" sortable>
      </el-table-column>
      <el-table-column prop="Impressions" label="展现量" width="50px" align="right" :key="124" sortable>
      </el-table-column>
      <el-table-column prop="Clicks" label="点击量" width="50px" align="right" :key="125" sortable>
      </el-table-column>
      <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right" :key="126" sortable>
        <template slot-scope="scope">
          {{ (scope.row["Click-through Rate"]*100).toFixed(2)+"%" }}
        </template>
      </el-table-column>
      <el-table-column prop="Spend" label="花费" width="50px" align="right" :key="127" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.Spend)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Sales" label="销售额" width="50px" align="right" :key="128" sortable>
        <template slot-scope="scope">
          {{ (Number(scope.row.Sales)).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Orders" label="订单数" width="50px" align="right" :key="129" sortable>
      </el-table-column>
      <el-table-column prop="Units" label="销售数量" width="50px" align="right" :key="130" sortable>
      </el-table-column>
      <el-table-column prop="Conversion Rate" label="转化率" width="50px" align="right" :key="131" sortable>
      </el-table-column>
      <el-table-column prop="ROAS" label="ROAS" width="50px" align="right" :key="132" sortable>
      </el-table-column>
    </el-table>

    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick">
    </el-pagination>
  </div>
</template>

<script>
import {
  requestModules
} from '@r'
import {
  products,
  activeProducts,
  colors,
  models
} from '../../utils/constant.js'
export default {
  data() {
    return {
      products: products,
      screenHeight: document.body.clientHeight - 64 - 54 - 68,
      total: 0,
      pageCount: 1,
      sku: "",
      productType: "1",
      productColor: "",
      advertData: [],
      productList: activeProducts,
      colorList: colors,
      viewModel: "1",
      params: { pageSize: 200, sku: this.sku, typeList: "1|2|3|4", date: new Date().format("yyyy-MM-dd"), beginIndex: 0, productType: "1", productColor: "黑色" }
    };
  },
  components: {
  },
  watch: {
    'params.productType': {
      handler: function (newValue, oldValue) {
        let product = this.products.find(product => product.productType == newValue);
        if (product) {
          let color = this.colorList.find(color => color.key == product.defaultColor);
          this.params.productColor = color.key;
        }
      },
      deep: true
    },
    products: {
      handler: function (newValue, oldValue) {
        let product = this.products && this.products.length > 0 ? this.products[0] : null;
        if (!product) {
          return;
        }

        this.params.productType = product.productType;
        this.params.productColor = product.defaultColor;

        this.getAdvertData()
      },
      deep: true
    }
  },
  mounted() {
    this.$eventBus.$on('resize', this.calculateHeight)

    let product = this.products && this.products.length > 0 ? this.products[0] : null;
    if (!product) {
      return;
    }

    this.params.productType = product.productType;
    this.params.productColor = product.defaultColor;

    this.getAdvertData()
  },
  beforeDestroy() {
    this.$eventBus.$off('resize', this.calculateHeight)
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 68
      console.log("calculateHeight", this.screenHeight)
    },
    clearState() {
      this.advertData.forEach(item => {
        let campainList = item.campainList;
        campainList.forEach(campain => {
          if (campain.Operation != "") {
            let params = {
              id: campain._id,
              Operation: ""
            }
            requestModules.updateProductAdvert(params).then(res => { });
          }
          if (campain.relateAdvert.Operation != "") {
            let params = {
              id: campain.relateAdvert._id,
              Operation: ""
            }
            requestModules.updateProductAdvert(params).then(res => { });
          }
        })
      })
    },
    onStateChange(row, listRow) {
      let params = {
        id: row._id,
        State: row.State
      }
      requestModules.updateProductAdvert(params).then(res => {
        this.$message({
          type: 'success',
          message: '修改成功!'
        });
      });

      let state = "已暂停";
      listRow.campainList.forEach(advert => {
        advert.State == "已启用" && (state = "已启用");
      });
      listRow.State = state;
    },
    onProductStateChange(row) {
      let campainList = row.campainList;
      campainList.forEach(campain => {
        campain.State = row.State;
        let params = {
          id: campain._id,
          State: row.State
        }
        requestModules.updateProductAdvert(params).then(res => { });
      });
      this.$message({
        type: 'success',
        message: '修改成功!'
      });
    },
    onDailyBudgetChange(row) {
      this.$confirm('是否确认修改每日预算?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let params = {
          id: row._id,
          "Daily Budget": row['Daily Budget']
        }
        requestModules.updateProductAdvert(params).then(res => {
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    onBidChange(row) {
      this.$confirm('是否确认修改单次点击价?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: row._id,
          Bid: row.Bid
        }
        requestModules.updateProductAdvert(params).then(res => {
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    onRecommandBidClick(row) {
      this.$confirm('是否确认修改单次点击价格?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: row._id,
          Bid: row.recommandBid
        }
        requestModules.updateProductAdvert(params).then(res => {
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
          row.Bid = row.recommandBid;
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    detailPage(row) {
      window.open("/client/keywordAdvertDetail?asin=" + row.asin)
    },
    searchKeydetailPage(row) {
      window.open("/client/searchKeywordMgmt?asin=" + row.asin)
    },
    queryBtn() {
      this.getAdvertData();
    },
    getAdvertData() {
      // !this.params.productColor && (this.params.productColor = "黑色");
      // !this.params.productType && (this.params.productType = 1);

      requestModules.fetchProductAdvertsOld(this.params).then(res => {
        this.advertData = res.ldata;
        this.total = res.total;
        this.pageCount = this.total % this.params.pageSize + 1;
      });
    },
    getInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 15 && (styleClass = "redBg");
      inventoryDay > 15 && inventoryDay <= 30 && (styleClass = "yellowBg");
      inventoryDay > 30 && inventoryDay <= 90 && (styleClass = "greenBg");
      inventoryDay > 90 && (styleClass = "redText");
      return styleClass;
    },
    getRecommendStyleClass(row) {
      let state = this.getRecommendState(row);
      let styleClass = "";
      if (state != row.State) {
        state == "enabled" && (styleClass = "greenBg");
        state == "enabled" && row.price > 8.5 && (styleClass = "yellowBg");
        state == "paused" && (styleClass = "redBg");
        state == "paused" && row.price < 6.5 && (styleClass = "yellowBg");
      }
      return styleClass;
    },
    getMajorLevelStyleClass(row) {
      let styleClass = "";
      row.majorLevel == "1" && (styleClass = "greenBg");
      row.majorLevel == "2" && (styleClass = "redBg");
      return styleClass;
    },
    getRecommendState(row) {
      let state = "paused";
      let { totalVisit, orderRate, totalCount, availableInventoryDay, inventoryDay, inventoryCount, reservedQuantity, speed } = { ...row };
      if (availableInventoryDay >= 90 && (Number(inventoryCount) + Number(reservedQuantity)) > 30) {
        state = "enabled"
      } else {
        if (speed < 0 && availableInventoryDay >= 60 && orderRate >= 0.08 && totalVisit > 100) {
          state = "enabled"
        }
      }
      // inventoryDay == 10000 && inventoryCount > 10 && (state = "enabled");
      // availableInventoryDay >= 90 && orderRate >= 0.08 && totalVisit < 100 && (state = "enabled");
      return state;
    },
    getRecommandBidStyleClass(row) {
      let styleClass = "";
      if (!row) {
        return;
      }
      row.recommandBid > row.Bid && (styleClass = "greenBg");
      row.recommandBid < row.Bid && (styleClass = "redBg");
      // row.recommandState == "2" && (styleClass = "redBg");
      return styleClass;
    },
    productDetail(row) {
      window.open("/client/productDetail?asin=" + row.asin)
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getAdvertData();
    },
    load(tree, treeNode, resolve) {
      let params = { pageSize: 100, campaignName: tree["Campaign Name (Informational only)"], adGroupName: tree["Ad Group Name (Informational only)"] };
      requestModules.fetchDetailProductAds(params).then(res => {
        let list = res.ldata;
        list.forEach(item => {
          item.Bid = "";
          item.relateAdvert = {};
          item.isDetail = true;
        })
        resolve(list);
      });
    },
    getSummaries(param) {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          let result = this.money[index]
          sums[index] = result
        } else {
          sums[index] = '';
        }
      });
      return sums;

    }
  },
  computed: {
    tableData() {
      let list = [...this.advertData];
      list.forEach(advert => {
        advert.campainList.forEach(ad => ad.hasChildren = true);
        advert.inventoryCount = parseInt(advert.inventoryCount);
        advert.reservedQuantity = parseInt(advert.reservedQuantity);
        advert.inboundQuantity = parseInt(advert.inboundQuantity);
        advert.inventoryDay = parseInt(advert.inventoryDay);
        advert.availableInventoryDay = parseInt(advert.availableInventoryDay);
      })
      // this.productType != "" && (list = list.filter(advert => advert.productType == this.productType));
      // this.productColor != "" && (list = list.filter(advert => advert.color == this.productColor));
      list.sort((a, b) => b.Spend - a.Spend);
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });

      return list
    }
  },
};
</script>

<style lang="scss">
#AdvertMgmtOld {
  .header-box {
    text-align: left;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 15px;
      margin-left: 5px;
      padding: 0px 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 20px;
    }

    .header-line:last-of-type {
      margin-bottom: 0px;
    }

    .small-margin-right {
      margin-right: 5px;
    }

    .header-label {
      font-size: 16px;
    }
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;
    text-align: right;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
    .greenText {
      color: red;
    }
    .greenYellowText {
      color: rgb(233, 104, 104);
    }
    .yellowText {
      color: rgb(112, 56, 56);
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell{
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
